module.exports = "/_next/static/images/e5cdeabf8b515475d3be7f6ed55c9da5-nubanker-xpeer@0.75x.jpg";